// Ponto ÚNICO que conhece o formato da diluição padrão do dispositivo.
//
// O backend guarda como objeto aninhado (`torre.diluicaoPadrao = { valor, updatedAt,
// updatedBy }`) — igual ao `sensorConfig` — para ter auditoria de quem/quando alterou.
// Se um dia esse formato mudar, muda-se só este arquivo.
//
// ⚠️ ARMADILHA: `0` é um preset LEGÍTIMO ("amostra pura" — o caso do efluente numa ETE),
// e é diferente de "sem preset". Por isso nunca usar `||` para ler esse valor:
//   errado:  t.diluicaoPadrao?.valor || 0     → 0 vira indistinguível de ausência
//   certo:   presetDiluicaoTorre(t) ?? 0

/** Preset de diluição do dispositivo (expoente 0..6), ou null se não configurado. */
export const presetDiluicaoTorre = (t) => {
    const v = t?.diluicaoPadrao?.valor;
    return Number.isInteger(v) ? v : null;
};

/** Rótulo curto do preset para exibir em chip: "10⁻⁴", "Pura" ou null. */
export const rotuloPresetDiluicao = (t) => {
    const v = presetDiluicaoTorre(t);
    if (v === null) return null;
    if (v === 0) return 'Pura';
    const sup = String(v).replace(/\d/g, (d) => '⁰¹²³⁴⁵⁶⁷⁸⁹'[Number(d)]);
    return `10⁻${sup}`;
};
